import { Component } from '@angular/core';

export interface FooterLink {
  label: string;
  url: string;
}

@Component({
  standalone: false,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})

export class FooterComponent {

  // Useful Links Array
  quickLinks: FooterLink[] = [
    { label: 'About us', url: '/about-us' },
    { label: 'Contact us', url: '/contact' },
    { label: 'Our Services', url: '/services' },
    { label: 'Portfolio', url: '/portfolio' },
    { label: 'Latest Blog', url: '/blog-grid' }
  ];

  // Help & Policy Links Array
  helpLinks: FooterLink[] = [
    { label: 'Terms Of use', url: '/' },
    { label: 'Privacy Policy', url: '/' },
    { label: 'Helps', url: '/' },
    { label: 'FQAs', url: '/' },
    { label: 'Contact', url: '/contact' }
  ];

  // Current Year for Copyright
  currentYear: number = new Date().getFullYear();

}
